@if (configs().length > 0) {
  <div class="flex flex-col gap-1 mt-2 pt-2 border-t border-base-200">
    <span class="text-xs font-semibold text-base-content/70">Frühere Versandvorgänge</span>
    @for (cfg of configs(); track cfg.id) {
      <div class="flex items-center gap-x-3 text-xs text-base-content/70 flex-wrap">
        <span class="bm-badge bm-badge-xs bm-badge-neutral">{{ cfg.shipping_type_label }}</span>
        @if (cfg.target_user_name) {
          <span>→ {{ cfg.target_user_name }}</span>
        }
        @if (cfg.shipped_at) {
          <span>{{ cfg.shipped_at | date:'dd.MM.yyyy HH:mm' }}</span>
        }
        @for (dn of cfg.delivery_notes ?? []; track dn.id) {
          <a [routerLink]="['/', 'lieferscheine', dn.id]"
             class="inline-flex items-center gap-1 link link-primary">
            <fa-icon [icon]="iconInvoice" />
            <span>{{ dn.number || ('Lieferschein #' + dn.id) }}</span>
          </a>
        }
      </div>
    }
  </div>
}
